import { useChatStore } from "../../../stores/ChatStore";

const ChatAnalytics = () => {
    const { setWindowActive } = useChatStore()

    const handleLabelClick = () => {
        setWindowActive('analytic-daily-chat-summary')
    }

    return (
        <div className='card card-flush w-100 p-10' style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)" }}>
            <h1 className="text-dark fw-bolder fs-1 my-1 mb-10">Analitik</h1>
            <div className="d-flex align-items-center p-3 rounded-2 bg-hover-light" onClick={handleLabelClick}>
                <div className="symbol symbol-30px me-5">
                    <span className="symbol-label">
                    <span className="svg-icon svg-icon-3 svg-icon-gray-600">
                            <i className="fas fa-chart-bar fa-bolt"></i>
                        </span>
                    </span>
                </div>
                <div className="me-5">
                    <span className="text-gray-800 fw-bolder fs-6">Ringkasan Chat Harian</span>
                    <span className="text-gray-400 fw-bold fs-7 d-block text-start ps-0">Data ringkasan chat harian</span>
                </div>
            </div>
        </div>
    )
}

export { ChatAnalytics }